import React from "react";
import { User } from "lucide-react";

// Indicador de origem: 🤖 robozinho (automático) x 👤 pessoa (manual).
// Usado em Chamados, histórico/comentários e solicitações de compra do Estoque.
export default function OriginIcon({ origin, size = 28, className = "" }) {
  const px = size;
  if (origin === "auto") {
    return (
      <span
        title="Automático — criado por e-mail / gerado pelo sistema"
        aria-label="Automático"
        className={`inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full ring-1 ring-blue-200 ${className}`}
        style={{ width: px, height: px }}
      >
        <img src="/img/robo.png" alt="" width={px} height={px} style={{ display: "block" }} />
      </span>
    );
  }
  return (
    <span
      title="Manual — feito por uma pessoa"
      aria-label="Manual"
      className={`inline-flex shrink-0 items-center justify-center rounded-full bg-gray-100 text-gray-500 ${className}`}
      style={{ width: px, height: px }}
    >
      <User size={Math.round(px * 0.56)} />
    </span>
  );
}
